import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrivateThreads } from 'store/chat/services/getPrivateThreads.service';

export const getPrivateThreadsThunk = createAsyncThunk(
  'chat/getPrivateThreads',
  async (_, { getState }) => {
    const threads = await getPrivateThreads();

    return threads.reduce((acc, thread, index) => {
      acc[thread.threadId] = thread;
      return acc;
    }, {});
  }
);
